export default {
    props: {
        attributes: {
            type: Object,
            default: undefined
        },
        buttons: {
            type: Array,
            default: undefined
        },
        click: {
            type: Function,
            default: undefined
        },
        enable: {
            default: true,
            type: Boolean
        },
        group: {
            type: String,
            default: undefined
        },
        hidden: {
            type: Boolean,
            default: undefined
        },
        icon: {
            type: String,
            default: undefined
        },
        id: {
            type: String,
            default: undefined
        },
        imageUrl: {
            type: String,
            default: undefined
        },
        menuButtons: {
            type: Array
        },
        overflow: {
            type: String,
            default: undefined
        },
        overflowTemplate: {
            type: [String, Function],
            default: undefined
        },
        primary: {
            type: Boolean,
            default: undefined
        },
        selected: {
            type: Boolean,
            default: undefined
        },
        showIcon: {
            type: String
        },
        showText: {
            type: String,
            default: undefined
        },
        spriteCssClass: {
            type: String,
            default: undefined
        },
        template: {
            type: [String, Function],
            default: undefined
        },
        text: {
            type: String,
            default: undefined
        },
        togglable: {
            type: Boolean,
            default: undefined
        },
        toggle: {
            type: Function
        },
        type: {
            type: String,
            default: undefined
        },
        url: {
            type: String,
            default: undefined
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoToolBar/Items.js